import React, { Component } from 'react';
import { Redirect } from 'react-router';
import PropTypes from 'prop-types';
import { MovieForm, Loading } from '../components';
import * as movieAPI from '../services/movieAPI';

// Feito com Gabriel Biasoli
class EditMovie extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: '',
      shouldRedirect: false,
      movie: {},
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const { match: { params: { id } } } = this.props;
    this.getMovie(id);
  }

  handleSubmit(updatedMovie) {
    this.setState({ status: 'loading' },
      async () => {
        const movie = await movieAPI.updateMovie(updatedMovie);
        this.setState({ status: '', movie, shouldRedirect: true });
      });
  }

  getMovie = (id) => {
    this.setState({ status: 'loading' },
      async () => {
        const movie = await movieAPI.getMovie(id);
        this.setState({ status: '', movie });
      });
  }

  render() {
    const { status, shouldRedirect, movie } = this.state;
    if (shouldRedirect) {
      return <Redirect to="/" />;
    }

    if (status === 'loading') {
      return <Loading />;
    }

    return (
      <div data-testid="edit-movie">
        <MovieForm movie={ movie } onSubmit={ this.handleSubmit } />
      </div>
    );
  }
}

EditMovie.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
};

export default EditMovie;
